<script lang="ts">
	import '@style/global.scss';
	import { PUBLIC_ENV_MODE } from '$env/static/public';
	import Debugging from '@comp/debugging/Debugging.svelte';
	import Theme from '@tools/styles/Theme.svelte';
	import { Head } from '@atoms';
	import { scrollLock } from '@tools/ScrollLock.svelte.js';
	import { Breakpoints, cookies } from '@tools';
	import { CookieNames } from '$lib/types/CookieNames.js';
	import { personalizationTracking } from '@tools/PersonalizationTracking.js';
	import { page } from '$app/stores';

	let { data, children } = $props();

	const theme = new Theme(data.globals.theme);
	personalizationTracking.init();

	let vh = $state(0);
	Breakpoints.set(data.breakpoint);

	$effect(() => {
		if (Breakpoints.current && cookies.consents.get('functional')) {
			cookies.set(CookieNames.BREAKPOINT, Breakpoints.current, 'functional');
		} else {
			cookies.delete(CookieNames.BREAKPOINT);
		}
	});

	$effect(() => {
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});

	const pageMetaTags = $page.data.page?._seoMetaTags ?? [];
</script>

<svelte:window bind:innerHeight={vh} />
<Head
	tags={[...data.globals._seoMetaTags, ...pageMetaTags]}
	suffix={data.globals.site.titleSuffix}
/>

{#if PUBLIC_ENV_MODE === 'development'}
	<Debugging />
{/if}

<main style={theme.css} bind:this={scrollLock.bind}>
	{@render children()}
</main>

<style lang="scss">
	main {
		position: relative;
		width: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: start;
	}
</style>
